import React, { useContext, useState } from 'react';
import Lightbox, { Slide } from 'yet-another-react-lightbox';

import LocResourcesContext from '../../../common/contexts/LocResourcesContext';
import { PDPProduct, PDPProductCustomerImage } from '../../model/BonusPointsProduct';

interface CustomerPicturesProps {
  product: PDPProduct;
}

const CustomerPictures: React.FC<CustomerPicturesProps> = ({ product }: CustomerPicturesProps) => {
  const GLOBAL_PREFIX = 'loy-bp-pdppui';
  const { onFormatLocale } = useContext(LocResourcesContext);
  const [pictureIndex, setPictureIndex] = useState<number>(0);
  const [isLightboxOpen, setIsLightboxOpen] = useState<boolean>(false);

  function getCustomerPictures(): PDPProductCustomerImage[] {
    return product.customerPictures.map((picture) => {
      return {
        ...picture,
        fileName400:
          'https://' +
          picture.fileName400.replace('-dev', '-prod').replace('shpmediad', 'shpmediap'),
        fileName800:
          'https://' +
          picture.fileName800.replace('-dev', '-prod').replace('shpmediad', 'shpmediap'),
        fileNameThumb:
          'https://' +
          picture.fileNameThumb.replace('-dev', '-prod').replace('shpmediad', 'shpmediap'),
      };
    });
  }

  function getLightboxSlides(): Slide[] {
    return getCustomerPictures().map((p) => {
      return {
        src: p.fileName800,
        srcSet: [
          { src: p.fileNameThumb, width: 50, height: 50 },
          { src: p.fileName400, width: 400, height: 400 },
          { src: p.fileName800, width: 800, height: 800 },
        ],
      };
    });
  }

  return (
    <div className={`${GLOBAL_PREFIX}_customer-pictures-gallery`}>
      {getCustomerPictures()
        .slice(0, 3)
        .map((pic, index) => {
          return (
            <img
              key={pic.fileNameThumb}
              src={pic.fileNameThumb}
              alt=""
              onClick={() => {
                setPictureIndex(index);
                setIsLightboxOpen(true);
              }}
              title={product.title}
            />
          );
        })}
      <Lightbox
        open={isLightboxOpen}
        index={pictureIndex}
        close={() => setIsLightboxOpen(false)}
        slides={getLightboxSlides()}
        styles={{ root: { '--yarl__color_backdrop': 'rgba(0, 0, 0, .8)' } }}
      />
      {getCustomerPictures().length > 3 && (
        <span
          onClick={() => {
            setPictureIndex(0);
            setIsLightboxOpen(true);
          }}>
          {onFormatLocale!('mzp.bonuspoints.tabs.more')}
        </span>
      )}
    </div>
  );
};

export default React.memo(CustomerPictures);
